const errors = {
  NoOffer: { devMessage: 'No offers available' },
  NoApplication: { devMessage: 'No current application found' },
  ApplicationExpired: { devMessage: 'Application expired' },
  InvalidState: { devMessage: 'Invalid application state' },
  Unauthenticated: { devMessage: 'User not authenticated' },
  BankDetailsError: { devMessage: 'Something went wrong while fetching bank details or validating account number.' },
  OffersExpired: {
    devMessage: 'Offers expired',
    salesAgentAction: 'Confirm with credit operations that offer is valid and then take necessary actions like UW case or creating new opp as advised by credit ops.',
  },
  OfferSelectFailed: {
    devMessage: 'Offer select failed, or the void of the superseded checkouts that precedes it did.',
    salesAgentAction: 'Confirm the customer is still logged in, then have them reprice and select again. If it keeps failing, checkout-ux-orchestrator or Komodo may be unavailable.',
  },
  OfferMismatch: {
    devMessage: 'Checkout offerUuid and selectedOffer mismatch',
    salesAgentAction: 'Direct customer to log out, then reprice to void checkout.',
  },
  ApplicationPendingApproval: {
    devMessage: 'Application pending approval',
    salesAgentAction: 'The application is not approved, access funds will be available after approval.',
  },
  MultiOwner: {
    devMessage: 'Multi-owner, not online checkout eligible.',
    salesAgentAction: 'Board loan offline and checkout offline.',
  },
  MissingTaxId: {
    devMessage: 'Merchant missing tax id.',
    salesAgentAction: 'Create case with operations. Once case is resolved, reprice and then have the customer try checkout.',
  },
  IdologyVerificationFailed: {
    devMessage: 'Idology verification failed',
    salesAgentAction: 'Create operations case for override and manually verify identity. Do not reprice after override is complete.',
  },
  NewUser: {
    devMessage: 'New applicant must go through sales assist',
    salesAgentAction: 'Direct customer to log out, then reprice.'
  },
  Maintenance: {
    devMessage: 'Scheduled maintenance is active',
  },
  CustomLinkRequired: {
    devMessage: 'SCC brute-force customer arrived without a unique checkout URL',
  },
} as const;

type AppErrorName = keyof typeof errors;
type AppErrorDef = (typeof errors)[AppErrorName];

class AppErrorBase extends Error {
  declare readonly name: AppErrorName;
  readonly salesAgentAction?: string;

  private constructor(name: AppErrorName, def: AppErrorDef) {
    super(def.devMessage);
    this.name = name;
    this.salesAgentAction = 'salesAgentAction' in def ? def.salesAgentAction : undefined;
    Object.setPrototypeOf(this, new.target.prototype);
  }

  static fromName(name: AppErrorName): AppErrorBase {
    return new AppErrorBase(name, errors[name]);
  }
}

type AppErrorStatics = {
  readonly [K in AppErrorName]: AppErrorBase;
};

export const AppError = AppErrorBase as typeof AppErrorBase & AppErrorStatics;

for (const name of Object.keys(errors) as AppErrorName[]) {
  Object.defineProperty(AppError, name, {
    get: () => AppErrorBase.fromName(name),
    enumerable: true,
    configurable: false,
  });
}

export type AppError = AppErrorBase;
